var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanningcycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27AAE1",
    fillRule: "evenodd",
    d: "M21.458 4.689a16.737 16.737 0 0 1 11.87 4.909 16.773 16.773 0 0 1 3.05 19.554.991.991 0 0 0-.142.269 16.77 16.77 0 0 1-6.77 6.786 1.005 1.005 0 0 0-.398.209 16.77 16.77 0 0 1-14.007.546 16.773 16.773 0 0 1 6.396-32.273h.001Zm7.869 33.507a18.408 18.408 0 0 1-7.87 1.748 18.472 18.472 0 1 1 16.73-10.606l1.314 1.315a2.943 2.943 0 0 1 .741 2.945l10.3 8.749a5.837 5.837 0 0 1 1.647 6.556 5.832 5.832 0 0 1-1.304 1.998 5.826 5.826 0 0 1-4.112 1.699h-.004c-.067 0-.148 0-.228-.005a5.855 5.855 0 0 1-4.205-2.042v-.001l-8.744-10.294a2.919 2.919 0 0 1-.86.128h-.455l.016-.038a2.954 2.954 0 0 1-1.65-.837l-1.317-1.315Zm1.835-.993.894.895a.947.947 0 0 0 1.344 0l4.69-4.69a.948.948 0 0 0-.003-1.34l-.895-.895a18.47 18.47 0 0 1-2.662 3.366 18.43 18.43 0 0 1-3.368 2.664Zm4.07 1.896 8.626 10.156a3.833 3.833 0 0 0 5.613.23 3.83 3.83 0 0 0-.226-5.62l-10.153-8.624-3.86 3.858Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningcycle);
export default __webpack_public_path__ + "static/media/planning cycle.aec1af2c464b37f943d06b0efd8d5df3.svg";
export { ForwardRef as ReactComponent };